import React, { useContext } from 'react';
import {
  Slider,
  Text,
  TextTag,
  styled
} from '@volkswagen-onehub/components-core';
import { getLang, getTranslations } from '../../translations';
import { useSelectedFilterStore } from '../../store/filtersv2';
import { formatDistance } from '../../utils/format';
import { replaceStringWithJSX } from '../../utils/replace-string-with-jsx';
import { UserLocationContext } from '../../UserLocation/UserLocationContext';

const DistanceContainer = styled.div``;

const StyledText = styled(Text)`
  margin: 0 0 8px;
`;

export const Distance = () => {
  const lang = getLang()
  const { labels } = getTranslations();
  const { postalCode } = useContext(UserLocationContext);
  const { selected, selectFilter } = useSelectedFilterStore();
  const { distance } = selected;
  const distances = [25, 50, 100, 250, 500];

  const handleChange = (i: number) => {
    selectFilter("distance", distances[i]);
  };

  return (
    <DistanceContainer>
      <StyledText id="distance-label" tag={TextTag.p}>
        {
          replaceStringWithJSX(labels.search_within, {
            distance: <Text bold>{ formatDistance(distance || 100, lang) }</Text>,
            postalCode: <Text bold>{ postalCode }</Text>
          })
        }
      </StyledText>
      <Slider
        min={0}
        max={4}
        defaultValue={distances.indexOf(Number(distance))}
        step={1}
        ariaLabelledby="distance-label"
        getValueText={i => formatDistance(distances[i], lang)}
        onChange={handleChange}
        hideValueBubbles
      />
    </DistanceContainer>
  );
};
